import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import MUIDataTable from "mui-datatables";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/auth-context";
import { getExperiments } from "../services/sandbox-api.service";

export default function ExperimentsListView() {

    const [loading, setLoading] = useState(true);
    const [columnsData, setColumnsData] = useState([]);

    const { user } = useAuth();
    const navigate = useNavigate();

    const clickActionElement = (value, tableMeta, updateValue) => {
        navigate(`/experiments/detail/${value}`);
    };

    const columns = [
        {
            name: "NAME",
            options: {
                filter: true,
            },
        },
        {
            name: "STATUS",
            options: {
                filter: true,
            },
        },
        {
            name: "DATE",
            options: {
                filter: true,
            },
        },
        {
            name: "ACTIONS",
            options: {
                filter: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <Button
                            onClick={() =>
                                clickActionElement(value, tableMeta)
                            }>
                            Modificar
                        </Button>
                    );
                },
            },
        },
    ];

    const options = {
        filter: true,
        selectableRows: "none",
        download: false,
        print: false,
        filterType: "dropdown",
        responsive: "simple",
        rowsPerPage: 10,
    };

    useEffect(() => {
        (async function () {
            try {
                const response = await getExperiments(user.accessToken);
                let dataList = [];
                const expData = response.data;
                dataList = expData.map((e) => {
                    return [e.name,e.status, new Date(e.createAt*1000).toLocaleDateString(), e.id];
                });
                setColumnsData(dataList);
                setLoading(false);
            } catch (e) {
                console.error(e);
            }
        })();
    }, []);
    

    return (
        <div className="container">
            <div className="experiment-list-container">
                <div className="form-exp-container">
                    <div className="form-exp-title">Experimentos</div>
                </div>
                <div className="experiment-users-table-container">
                    {!loading && (
                        <MUIDataTable
                            className="table-no-shadown"
                            title={""}
                            data={columnsData}
                            columns={columns}
                            options={options}
                        />
                    )}
                </div>
                {loading && (
                    <div className="loader-experiments-list">
                        <div className="loader-experiments-icon-container">
                            <CircularProgress />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
